import { render, staticRenderFns } from "./FormTotalPPO.vue?vue&type=template&id=5a019d34"
import script from "./FormTotalPPO.vue?vue&type=script&lang=js"
export * from "./FormTotalPPO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports